import ComponentTitle from "../ComponentTitle";
import FormSendEmail from "./FormSendMail";
import DetailContactMe from "./DetailContactMe";
import {useEffect} from "react";
import Aos from "aos";

const ContactMe = ({detailContact}) => {
    useEffect(() => {
        Aos.init({
            duration: 800,
            once: true
        });
    }, []);

    return(
        <section 
            id={"contact"} 
            className="py-20 bg-slate-50 dark:bg-slate-900 transition-colors duration-300 relative overflow-hidden"
        >
            {/* Subtle separator line top */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-slate-700 to-transparent"></div>
            
            <div className="container mx-auto px-6 lg:px-8 relative z-10">
                <div data-aos="fade-up">
                    <ComponentTitle title={'Contact Me'} subTitle={'Let\'s work together and bring your ideas to life'} />
                </div>
                
                <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 max-w-6xl mx-auto">
                    <div data-aos="fade-right" data-aos-delay="200">
                        <FormSendEmail />
                    </div>
                    <div data-aos="fade-left" data-aos-delay="250">
                        <DetailContactMe detailContact={detailContact} />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default ContactMe;
